<template>
  <div class="page-wrap">
    <div class="news-wrap">
      <div class="news">
        <div class="news-title" v-html="title"></div>
        <div class="news-content" v-html="content"></div>
      </div>
      <div class="others">
        <div class="module-label">其他动态</div>
        <div class="others-list">
          <div class="others-item" v-for="(item, index) in list" :key="index">
            <router-link :to="'/News/' + item.id" class="others-link" tag="div">
              {{item.title}}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <bottom style="flex: 0 0 2.2rem;"></bottom>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsContent: {
        '1': {
          title: '校招卓越人才奖金',
          content: '在校招考核中，技术水平得分突出的软件人才，入职可享6w卓越人才奖金。获得国家级竞赛名次的，奖金可升档。'
        },
        '2': {
          title: '应届毕业生住房补贴保障政策',
          content: `自2024年起，软件开发岗位、证券/期货研究岗位的应届毕业生入职文华，凡不满足申领政府住房补贴条件的，由公司给予2年住房补贴。`
        },
        '3': {
          title: '社招安卓岗位签约可享签字费',
          content: `安卓开发岗位主要是负责文华财经旗下各项手机APP的开发工作。目前社招安卓岗位有“签字费”政策。既与公司新签订“安卓开发工程师”岗位劳动合同的优秀人才，可获得一次性签字费。同时文华也能给你满意的发展机会。岗位开放中，欢迎优秀人才的加入。`
        },
        '4': {
          title: '文华苏州新研发中心楼宇建设已完工',
          content: `<p>文华财经苏州研发中心大楼已完工。新研发中心位于苏州工业园区金鸡湖畔，楼高20层，将成为文华财经的第二总部。目前已经开始接受人员的转入。</p>
              <p>文华员工政策表示：未来，文华的员工可以有多个工作地点的选择，苏州、上海、大连，你想在哪里工作都可以。</p>`
        }
      },
      title: '',
      content: '',
      list: []
    };
  },
  methods: {
    makeList(id) {
      this.list = [];
      Object.keys(this.newsContent).forEach(item=>{
        if (id != item) {
          this.list.push({id: item, title: this.newsContent[item].title})
        }
      })
    }
  },
  watch: {
    '$route.params': {
      handler(val) {
        let {id} = val;
        this.title = this.newsContent[id]?.title || '',
        this.content = this.newsContent[id]?.content || '';
        this.makeList(id);
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.page-wrap {
  position: absolute;
  bottom: 0;
  overflow-y: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10;
  background-color: #fff;
}
.news-wrap {
  padding: 0 0.54rem;
}
.news {
  min-height: 16rem;
}
.news-title {
  margin: 1.86rem 0 1rem 0;
  font-weight: bold;
  font-size: 0.65rem;
  text-align: center;
}
.news-content {
  font-size: 0.58rem;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 1rem;
}
.news-content >>> p {
  text-indent: 2em;
  line-height: 2;
  margin: 0;
}
.others {
  padding: 2rem 0;
}
.others-list .others-item {
  height: 1.334rem;
  border-bottom: 1px #ababab dashed;
  line-height: 1.334rem;
  font-size: 0.58rem;
}
</style>